exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color[data-v-f0a9801a] {\n  margin: .5rem .3rem;\n  height: 1.5rem;\n  width: 1.5rem;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.no-border-shadow[data-v-f0a9801a]:focus {\n  outline: none;\n}\n.row-even[data-v-f0a9801a] {\n  justify-content: space-evenly;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f0a9801a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/utils/ColorPicker.vue
// module id = 1320
// module chunks = 2